/**
 * Checks that an integration JWT carries the claims the integration APIs
 * require (vytal_store_id, vytal_merchant_id, imac). A token missing them was
 * minted while the store's DefaultStockUserId was not set correctly.
 */
export function validateJwtClaims(token: string) {
  if (!token) return { isValid: false };

  try {
    const base64 = token.split('.')[1];
    if (!base64) return { isValid: false };

    const decoded = JSON.parse(atob(base64));

    const hasStoreId = !!decoded.vytal_store_id;
    const hasMerchantId = !!decoded.vytal_merchant_id;
    const hasImac = decoded.imac === 't';

    return {
      isValid: hasStoreId && hasMerchantId && hasImac,
    };
  } catch (error) {
    console.error('Failed to decode JWT token:', error);
    return { isValid: false };
  }
}
